import { FooterProps } from '../models'

import facebook from '../../../../../assets/img/iconos_facebook.svg'
import twitter from '../../../../../assets/img/iconos_twitter.svg'
import youtube from '../../../../../assets/img/iconos_youtube.svg'
import instagram from '../../../../../assets/img/iconos_instagram.svg'
import tikTok from '../../../../../assets/img/iconos_tik-tok.svg'

export const FooterSocials = (props: FooterProps) => {
    const { facebookUrl, twitterUrl, youtubeUrl, instagramUrl, tikTokUrl } = props

    const placeholderSocials = [
        {
            name: 'Twitter',
            link: twitterUrl,
            icon: twitter
        },
        {
            name: 'Facebook',
            link: facebookUrl,
            icon: facebook
        },
        {
            name: 'Youtube',
            link: youtubeUrl,
            icon: youtube
        },
        {
            name: 'Instagram',
            link: instagramUrl,
            icon: instagram
        },
        {
            name: 'Tiktok',
            link: tikTokUrl,
            icon: tikTok
        }
    ]

    return (
        <ul className="social-icons">
            {placeholderSocials.map((item, index) => {
                if (!item.link) {
                    return
                } else {
                    return (
                        <li key={index}>
                            <a className="social-icons__item" href={item.link}>
                                <img src={item.icon} className="logo-image" alt={item.name} />
                            </a>
                        </li>
                    )
                }
            })}
        </ul>
    )
}
